import {useCallback, useState} from 'react';
import {QuestionStatus} from '@cp/model';
import {env} from '../../config/env';
import {useCountQuestions} from './useCountQuestions';

export interface CountQuestionsByStatusVariables {
  moduleId: string;
  topics?: string[];
  difficulties?: number[];
}

export function useCountQuestionsByStatus() {
  const {countQuestions, loading, error} = useCountQuestions();
  const [questionCounts, setQuestionCounts] = useState<Record<QuestionStatus, number> | null>(null);

  const fetchCountsByStatus = useCallback(
    async (variables: CountQuestionsByStatusVariables) => {
      const counts: Record<QuestionStatus, number> = {} as Record<QuestionStatus, number>;

      // Count questions for each status
      const statuses = env.question.order;

      await Promise.all(
        statuses.map(async (status) => {
          const count = await countQuestions({
            moduleId: variables.moduleId,
            topics: variables.topics,
            difficulties: variables.difficulties,
            statuses: [status],
          });
          counts[status] = count;
        }),
      );

      setQuestionCounts(counts);
      return counts;
    },
    [countQuestions],
  );

  return {
    fetchCountsByStatus,
    questionCounts,
    loading,
    error,
  };
}
